// extracted by mini-css-extract-plugin
export default {"iframeSize":"iframeTest_iframeSize__sowxc"};